import React, { useState } from "react";
import { toAbsoluteUrl } from "../../../services";
import Dropdown from "../dropdown/dropdown";
import { MenuAlt2Icon } from "@heroicons/react/solid";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../constants/routes";

function MainLayout(props) {
  const [mobileMenu, setMobileMenu] = useState(false);
  let navigate = useNavigate();

  let handleMenu = () => {
    setMobileMenu(!mobileMenu);
  };
  return (
    <div className="w-full">
      {/* Header Start */}
      <div
        className="bg-cover 2xl:h-[12rem] xl:h-[12rem] lg:h-[12rem] md:h-[14rem]  h-[16rem]"
        style={{
          backgroundImage: `url(${toAbsoluteUrl("/media/nrp/bg/bg.png")})`,
          width: "100%",
        }}
      >
        {/* <!-- Navbar goes here --> */}
        <nav>
          <div className="mx-auto px-4">
            <div className="flex 2xl:justify-around xl:justify-around lg:justify-around justify-between">
              <div>
                {/* <!-- Website Logo --> */}
                <div className="cursor-pointer flex items-center py-6 ">
                  <img
                    onClick={() => {
                      // props.handleMainTab();
                      navigate(`${ROUTES.HOME}`, { replace: true });
                    }}
                    alt="Logo"
                    src={toAbsoluteUrl("/media/nrp/home/logo.png")}
                    style={{ marginTop: "-7px", marginRight: "40px" }}
                  />
                </div>
              </div>
              {/* <!-- Primary Navbar items --> */}
              <div className="hidden md:flex items-center space-x-1 ml-10"></div>
              {/* <!-- Secondary Navbar items --> */}
              <div className="hidden md:flex items-center space-x-8 ">
                <Dropdown
                  logout={props.logout}
                  // stepHandler={props.handleMainTab}
                />
              </div>
              {/* <!-- Mobile menu button --> */}
              <div className="md:hidden flex items-center">
                <button
                  onClick={handleMenu}
                  className="outline-none mobile-menu-button"
                >
                  <MenuAlt2Icon className="h-5 w-5 text-white" />
                </button>
              </div>
            </div>
          </div>
          {/* <!-- mobile menu --> */}
          {mobileMenu ? (
            <div className="2xl:hidden xl:hidden lg:hidden md:hidden mobile-menu ">
              {/* <!-- Secondary Navbar items --> */}
              <div className=" items-center space-x-3  ml-9 mt-2">
                <div className="mt-2">
                  <Dropdown
                    logout={props.logout}
                    // stepHandler={props.handleMainTab}
                  />
                </div>
              </div>
            </div>
          ) : null}
        </nav>
      </div>
      {/* Body Start */}
      {props.children}

    </div>
  );
}

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {
  // handleMainTab,
})(MainLayout);
